import { Recording, State } from './types';

const getters = {
  getRecordings(state: State): Array<Recording> {
    return Object.values(state.recordings);
  }
};

export default getters;
